import { z } from 'zod'

export * as printPreferences from './printPreferences'

export const nidoErrorSchema = z.object({
  status: z.number(),
  body: z.object({ message: z.string() }),
})
